import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  holiday_type_name: yup.string().required(VALIDATION.required).max(191, VALIDATION.max),
  rate_of_basic: yup.string().required(VALIDATION.required),
})
